module.exports = __webpack_public_path__ + "img/20.413f970e.png";